module.exports = __webpack_public_path__ + "static/media/success.d85fef51.jpg";